'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _LockIcon = require('../LockIcon');

var _LockIcon2 = _interopRequireDefault(_LockIcon);

var _CloseMediaPlayerIcon = require('../CloseMediaPlayerIcon');

var _CloseMediaPlayerIcon2 = _interopRequireDefault(_CloseMediaPlayerIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PersistentMediaPlayerCTA = function PersistentMediaPlayerCTA(_ref) {
  var backgroundImageURL = _ref.backgroundImageURL,
      ctaHref = _ref.ctaHref,
      displayCloseIcon = _ref.displayCloseIcon,
      doToggleVisibility = _ref.doToggleVisibility,
      message = _ref.message,
      onClickHandler = _ref.onClickHandler;
  return _react2.default.createElement(
    'div',
    {
      className: 'quiver-persistent-cta',
      style: { backgroundImage: backgroundImageURL ? 'url(' + backgroundImageURL + ')' : '' }
    },
    _react2.default.createElement(
      'div',
      { className: 'quiver-persistent-cta__overlay' },
      _react2.default.createElement(_LockIcon2.default, null),
      _react2.default.createElement(
        'p',
        null,
        message
      ),
      _react2.default.createElement(
        'a',
        { href: ctaHref, onClick: onClickHandler },
        'Go Premium'
      ),
      displayCloseIcon ? _react2.default.createElement(
        'div',
        {
          onClick: doToggleVisibility,
          className: 'quiver-persistent-cta__close'
        },
        _react2.default.createElement(_CloseMediaPlayerIcon2.default, { className: 'quiver-persistent-cta__close-icon' })
      ) : null
    )
  );
};

PersistentMediaPlayerCTA.propTypes = {
  backgroundImageURL: _propTypes2.default.string,
  ctaHref: _propTypes2.default.string.isRequired,
  displayCloseIcon: _propTypes2.default.bool,
  doToggleVisibility: _propTypes2.default.func,
  message: _propTypes2.default.string.isRequired,
  onClickHandler: _propTypes2.default.func.isRequired
};

PersistentMediaPlayerCTA.defaultProps = {
  backgroundImageURL: null,
  displayCloseIcon: false,
  doToggleHomeCamVisibility: null
};

exports.default = PersistentMediaPlayerCTA;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/PersistentMediaPlayerCTA/PersistentMediaPlayerCTA.js
// module id = 629
// module chunks = 11